module.exports = __webpack_public_path__ + "static/media/icon-supplies-cuticle-cutter.3d755bb8.svg";